<template>
  <q-dialog :visible="isVisible" :title="title" width="600px" :innerHeight="200" @confirm="onConfirm" @cancel="onCancel">
    <el-form :model="form" :rules="rules" label-width="95px" ref="formRef">
      <el-form-item label="导入模板:">
        <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
      </el-form-item>
      <el-form-item label="文件：" prop="file">
        <el-upload
          :file-list="fileList"
          class="upload-block"
          :http-request="upload"
          :limit="1"
          action="*"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :on-change="onFileChange"
          :auto-upload="false"
          ref="uploadRef"
        >
          <el-button size="small" type="primary">选择文件</el-button>
          <template #tip>
            <div class="el-upload__tip">只能上传xls、xlsx文件，且大小不能超过10MB</div>
          </template>
        </el-upload>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>
<script>
export default {
  name: 'ImportExcelDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    listNo: [Number, String],
  },
  data() {
    return {
      form: {
        file: '',
      },
      rules: {
        file: [{ required: true, message: '导入文件不能为空', trigger: 'change' }],
      },
      fileList: [],
      templateData: {},
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '导入基础信息';
    },
  },
  mounted() {},
  methods: {
    downloadTemplate() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$q.newProduct.downBaseTemplate({ data: {}, options: { responseType: 'blob' } }).then((res) => {
        let fileName = '基础信息未维护导入模板';
        this.blobDownload(res, `${fileName}.xlsx`);
        loading.close();
      });
    },
    beforeUpload(file) {
      const excelTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      if (!excelTypes.includes(file.type)) {
        ElMessage.error('只能上传Excel文件');
        return false;
      }
      return true;
    },
    onFileChange(file) {
      this.form.file = file;
      this.$refs.formRef.validateField('file');
    },
    upload({ file }) {
      if (!file) {
        this.$message.error('请选择要上传的文件');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const _this = this;
      const data = new FormData();
      data.append('listNo', this.listNo);
      data.append('file', file);
      this.$q.newProduct
        .importBaseData({ data: data })
        .then((res) => {
          if (res.code == 200 && res.message) {
            var timer = setInterval(function () {
              _this.$q.common
                .reportTaskInfo({ fragment: [res.message] })
                .then((res) => {
                  if (res.data.taskStatus == '执行完成') {
                    clearInterval(timer);
                    loading.close();
                    if (res.data.taskResult == '成功') {
                      _this.$message.success('导入操作已执行，请前往导入列表查看导入结果！');
                      _this.onCancel();
                      _this.$emit('success');
                    } else {
                      _this.$notify.error({
                        message: res.data.failReason || '导入数据失败，请重新导入！',
                        duration: 0
                      });
                    }
                  }
                })
                .catch((err) => {
                  loading.close();
                });
            }, 5000);
          } else {
            this.$notify.error({
              message: res.message,
              duration: 0
            });
          }
        })
        .catch((err) => {
          loading.close();
        });
    },
    // const loading = this.$loading({
    //     lock: true,
    //     text: '图片上传中...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(255, 255, 255, 0.7)',
    //   });
    //   this.$q.newProduct
    //     .productModelBatchUpload({ data: form })
    //     .then((res) => {
    //       if (res.code == 200 && res.data) {
    //         var timer = setInterval(function () {
    //           _this.$q.common
    //             .reportTaskInfo({ fragment: [res.data] })
    //             .then((res) => {
    //               if (res.data.taskStatus == '执行完成') {
    //                 clearInterval(timer);
    //                 loading.close();
    //                 if (res.data.taskResult == '成功') {
    //                   _this.$message.success('上传成功');
    //                   _this.isVisible = false;
    //                   _this.$emit('complete');
    //                 } else {
    //                   _this.onCancelImport();
    //                   _this.$message.error(res.data.failReason);
    //                 }
    //               }
    //             })
    //             .catch((err) => {
    //               loading.close();
    //               this.$message.error(err.message);
    //             });
    //         }, 5000);
    //       } else {
    //         this.$message.error(res.message);
    //       }
    //     })
    //     .catch((_) => {
    //       loading.close();
    //     });
    async onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.$refs.uploadRef.submit();
      });
    },
    onCancel() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.upload-block {
  width: 100%;
}
</style>
